import React, {useContext, useState} from 'react';
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {injectIntl} from "react-intl";
import {getLocalizedMessage} from "../../../util/Localization";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import {
    checkTesseractAddTestPackageModalValidations,
    isValidEntry,
    PATTERNS
} from "../../../util/Validations";
import Input from "@amzn/meridian/input";
import {getShippingIdFromScannableList, getStowConfigScannableList} from "../../../util/Util";
import {CONFIG_TYPE} from "../../../util/Constants";
import Alert from "@amzn/meridian/alert";
import Button from "@amzn/meridian/button";

const AddTesseractTestPackageModal = (props) => {

    const {mac, intl} = props;
    const {getDraftData, addInstance, editInstance} = useContext(DraftContext);

    // Visual controls
    const {open, setOpen} = props;
    const [show, setShow] = useState(false);
    const [edit, setEdit] = useState(false);

    // Values
    const [trackingId, setTrackingId] = useState("");
    const [shippingId, setShippingId] = useState("");
    const [destination, setDestination] = useState("");

    // Error
    const [trackingIdErr, setTrackingIdErr] = useState(false);
    const [shippingIdErr, setShippingIdErr] = useState(false);
    const [destinationErr, setDestinationErr] = useState(false);

    const setConfigData = (stowTestPackage, mac) => {
        if(edit) {
            editInstance({
                stateKey: CONFIG_TYPE.TESSERACT_TEST_CONFIGURATION,
                subKey: mac,
                instance: stowTestPackage,
                keyComparator: (config1, config2) => (
                    config1.trackingId === config2.trackingId
                ),
                valueComparator: (config1, config2) => (
                    ((config1.scannables === config2.scannables) && (config1.destination === config2.destination))
                )
            })
        } else {
            addInstance({
                stateKey: CONFIG_TYPE.TESSERACT_TEST_CONFIGURATION,
                subKey: mac,
                instance: stowTestPackage
            });
        }
    }

    const stowTestPackage = {
        trackingId: trackingId,
        scannables: getStowConfigScannableList(trackingId, shippingId),
        destination: destination
    }

    let testConfigMap = {}
    getDraftData({stateKey: CONFIG_TYPE.TESSERACT_TEST_CONFIGURATION, subKey: mac}).forEach((value) => {
        testConfigMap[value.trackingId] = {
            shippingId: getShippingIdFromScannableList(value.scannables, value.trackingId),
            destination: value.destination
        }
    })

    const resetConfigDetails = () => {
        setShippingId("")
        setDestination("");
    }

    const resetConfigErrorDetails = () => {
        setShippingIdErr("")
        setDestinationErr(false);
    }

    function resetInputState() {
        setTrackingId("")
        resetConfigDetails();
        resetConfigErrorDetails();
    }

    function onCloseModal() {
        setShow(false);
        setOpen(false);
        resetInputState();
    }

    const prefill = () => {
        const key = stowTestPackage.trackingId
        if (testConfigMap.hasOwnProperty(key)) {
            setEdit(true);
            resetConfigErrorDetails();
            setShippingId(testConfigMap[key].shippingId);
            setDestination(testConfigMap[key].destination);
        } else if (edit) {
            setEdit(false);
            resetConfigDetails()
        }
    }

    const onClickConfirm = (stowTestPackage, mac) => {
        if (checkTesseractAddTestPackageModalValidations(stowTestPackage)) {
            setConfigData(stowTestPackage, mac);
            setOpen(false);
            resetInputState();
            setShow(false);
        } else {
            setShow(true);
        }
    }

    return (
        <Row>
            <Modal title={getLocalizedMessage({intl, stringId: "stowtestconfig.addupdate"})}
                   open={open}
                   onClose={onCloseModal}
                   scrollContainer="viewport"
                   closeLabel="Close"
                   bodySpacingInset="medium">
                <Column>
                    <Column spacing="200">
                        <b>
                            {getLocalizedMessage({intl, stringId: "modal.tesseract_headingtest"})}
                        </b>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({intl, stringId: "test.tracking_id"})}
                        </Text>
                        <Input id="tracking-id-input"
                               value={trackingId}
                               onChange={(value) => {setTrackingId(value.replace(/\s/g, ''))}}
                               onBlur={() => {
                                   setTrackingIdErr(!isValidEntry(trackingId, PATTERNS.TEST_PACKAGE_ID));
                                   prefill();
                               }}
                               error={trackingIdErr}
                               helperText={getLocalizedMessage({intl, stringId: "test.tracking_id_description"})}/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({intl, stringId: "test.alt_id"})}
                        </Text>
                        <Input id="scannables-input"
                               value={shippingId}
                               onChange={(value) => {setShippingId(value.replace(/\s/g, ''))}}
                               onBlur={() => {
                                   if(shippingId) {
                                       setShippingIdErr(!isValidEntry(shippingId, PATTERNS.TEST_PACKAGE_ID));
                                   }
                               }}
                               error={shippingIdErr}
                               helperText={getLocalizedMessage({intl, stringId: "test.alt_id_description"})}/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({intl, stringId: "test.destination"})}
                        </Text>
                        <Input id="destination-input"
                               value={destination}
                               onChange={setDestination}
                               onBlur={() => {
                                   setDestinationErr(!isValidEntry(destination, PATTERNS.CONTAINER_LABEL));
                               }}
                               error={destinationErr}
                               helperText={getLocalizedMessage({intl, stringId: "modal.tesseract_window_description"}) }/>
                    </Column>
                </Column>
                <ModalFooter>
                    <Column spacing="400">
                        {
                            show && !checkTesseractAddTestPackageModalValidations(stowTestPackage) &&
                                <Alert type="warning" size="small">
                                    {getLocalizedMessage({intl, stringId: "alert.missingfields"})}
                                </Alert>
                        }
                    </Column>
                    <Column spacing="200">
                        <Row alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="medium" onClick={onCloseModal}>
                                {getLocalizedMessage({intl, stringId: "modal.cancel"})}
                            </Button>
                            <Button type="primary" size="medium"
                                    onClick={() => onClickConfirm(stowTestPackage, mac)}>
                                {edit ? getLocalizedMessage({intl, stringId: "modal.confirmUpdate"})
                                    : getLocalizedMessage({intl, stringId: "modal.confirmAdd"})}
                            </Button>
                        </Row>
                    </Column>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(AddTesseractTestPackageModal)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/tesseract/modal/AddTesseractTestPackageModal.js